import { ApiError, QueryKeys, SystemMessageConfiguration } from '@connect-x-app/shared-domain-models';
import { getSystemMessages } from '@connect-x-app/web-data-access';
import { useQuery } from '@tanstack/react-query';

export const useSystemMessages = () =>
  useQuery<Required<SystemMessageConfiguration>, ApiError>({ queryFn: getSystemMessages, queryKey: [QueryKeys.SYSTEM_MESSAGES] });
